const View = require('./view.js');
const Controller = require('./controller.js');

module.exports = function() {
  this.view = new View();

  // Fail gracefully if browser unsupported
  if(!this.view.isSupportedBrowser()) {
    this.view.render('error', 'Custom Checkout is not supported by browser');
    return;
  }

  this.controller = new Controller(this.view);

  // API endpoints:
  return {
    create: this.controller.create,
    on: this.controller.on,
    createToken: this.controller.createToken,
  };
};


// WEBPACK FOOTER //
// ./app/main/index.js